import {
  ORDER_MESSAGE_ALL,
  ORDER_MESSAGE_GET,
  ORDER_MESSAGE_POST,
  ORDER_MESSAGE_PUT,
  ORDER_MESSAGE_DEL,
  ORDER_MESSAGE_LOADING,
  ORDER_MESSAGE_ERROR,
} from '../../actions/types';

const initialState = {
  ORDER_Message: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case ORDER_MESSAGE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case ORDER_MESSAGE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case ORDER_MESSAGE_POST:
      return { isLoading: false, isCompleted: true };
    case ORDER_MESSAGE_PUT:
      return { isLoading: false, isCompleted: true };
    case ORDER_MESSAGE_DEL:
      return { isLoading: false, isCompleted: true };
    case ORDER_MESSAGE_LOADING:
      return { isLoading: true, isCompleted: true };
    case ORDER_MESSAGE_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
